var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
export class AnonymousCartService {
    constructor(apiRoot, projectKey) {
        this.apiRoot = apiRoot;
        this.projectKey = projectKey;
    }
    getActiveCart() {
        return __awaiter(this, void 0, void 0, function* () {
            const cartId = localStorage.getItem("anonymousCartId");
            if (!cartId)
                throw new Error("No anonymous cart found.");
            const response = yield this.apiRoot
                .withProjectKey({ projectKey: this.projectKey })
                .me()
                .carts()
                .withId({ ID: cartId })
                .get()
                .execute();
            return response.body;
        });
    }
    createCart() {
        return __awaiter(this, void 0, void 0, function* () {
            const anonymousId = localStorage.getItem("anonymousId") || crypto.randomUUID();
            localStorage.setItem("anonymousId", anonymousId);
            const body = {
                currency: "EUR",
                anonymousId,
            };
            const response = yield this.apiRoot
                .withProjectKey({ projectKey: this.projectKey })
                .me()
                .carts()
                .post({ body })
                .execute();
            localStorage.setItem("anonymousCartId", response.body.id);
            return response.body;
        });
    }
    updateCart(cartId, payload) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiRoot
                .withProjectKey({ projectKey: this.projectKey })
                .me()
                .carts()
                .withId({ ID: cartId })
                .post({ body: payload })
                .execute();
            return response.body;
        });
    }
    changeLineItemQuantity(cartId, version, lineItemId, quantity) {
        return __awaiter(this, void 0, void 0, function* () {
            const payload = {
                version,
                actions: [
                    {
                        action: "changeLineItemQuantity",
                        lineItemId,
                        quantity,
                    },
                ],
            };
            const response = yield this.apiRoot
                .withProjectKey({ projectKey: this.projectKey })
                .carts()
                .withId({ ID: cartId })
                .post({ body: payload })
                .execute();
            return response.body;
        });
    }
    addDiscountCode(cartId, version, code) {
        return __awaiter(this, void 0, void 0, function* () {
            const payload = {
                version,
                actions: [
                    {
                        action: "addDiscountCode",
                        code,
                    },
                ],
            };
            const response = yield this.apiRoot
                .withProjectKey({ projectKey: this.projectKey })
                .carts()
                .withId({ ID: cartId })
                .post({ body: payload })
                .execute();
            return response.body;
        });
    }
    removeDiscountCode(cartId, version, discountCodeId) {
        return __awaiter(this, void 0, void 0, function* () {
            const payload = {
                version,
                actions: [
                    {
                        action: "removeDiscountCode",
                        discountCode: {
                            typeId: "discount-code",
                            id: discountCodeId,
                        },
                    },
                ],
            };
            const response = yield this.apiRoot
                .withProjectKey({ projectKey: this.projectKey })
                .me()
                .carts()
                .withId({ ID: cartId })
                .post({ body: payload })
                .execute();
            return response.body;
        });
    }
}
